const body1 = () => {
  return {
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: "0.96px",
  };
};

export { body1 };
